// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"53ebd5b7","230":"dee3fa1c","316":"4afebc38","454":"e07eca7d","472":"3a3ae8f9","497":"b0cd52d6","770":"9375fd0d","916":"39153366"}[chunkId] + ".chunk.js";
};